import { useMemo } from "react";

import { type ViewColumnDef, type ViewSpec } from "@moment/api-collab/api-types";

export interface HydratedViewColumnDefs {
	primaryDisplayColumn: ViewColumnDef | undefined;
	topRightColumns: [number, ViewColumnDef][];
	bottomRightColumns: [number, ViewColumnDef][];
	bottomLeftColumns: [number, ViewColumnDef][];
	unplacedColumns: [number, ViewColumnDef][];
	allColumns: ViewColumnDef[];
}

export const useHydratedColumnDefs = (viewSpec: ViewSpec | undefined): HydratedViewColumnDefs => {
	return useMemo(() => {
		const allColumns = viewSpec?.columns ?? [];

		let primaryDisplayColumn: ViewColumnDef | undefined;
		const topRightColumns: [number, ViewColumnDef][] = [];
		const bottomRightColumns: [number, ViewColumnDef][] = [];
		const bottomLeftColumns: [number, ViewColumnDef][] = [];
		const unplacedColumns: [number, ViewColumnDef][] = [];
		for (const [index, d] of allColumns.entries()) {
			if (d.visibleOnCard === false) {
				continue;
			}

			if (d.primaryDisplayColumn) {
				primaryDisplayColumn = d;
				continue;
			}

			if (d.placementHint === "top-right" && topRightColumns.length < 2) {
				topRightColumns.push([index, d]);
			} else if (d.placementHint === "bottom-right" && bottomRightColumns.length < 2) {
				bottomRightColumns.push([index, d]);
			} else if (d.placementHint === "bottom-left" && bottomLeftColumns.length < 2) {
				bottomLeftColumns.push([index, d]);
			} else {
				unplacedColumns.push([index, d]);
			}
		}

		return {
			primaryDisplayColumn,
			topRightColumns,
			bottomRightColumns,
			bottomLeftColumns,
			unplacedColumns,
			allColumns,
		};
	}, [viewSpec]);
};
